import { DarkLogo, LightLogo } from '@energy-stacks/theme';
import { useTheme } from '@mui/material';

export const Logo = () => {
  const { palette } = useTheme();

  return palette.mode === 'dark' ? <LightLogo /> : <DarkLogo />;
};
